// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"69de8099","596":"cef01ac7","669":"26680eb0","677":"c26b4950","679":"19002947"}[chunkId] + ".chunk.css";
};